export enum OrganizationLinkMode {
  LinkByOrganization = "LinkByOrganization",
  LinkToOrganization = "LinkToOrganization",
}
